export function getIdsArray(ids: string | string[] | undefined): string[] | null {
  if (!ids) {
    return null;
  }

  return Array.isArray(ids) ? ids : ids.replaceAll(/\s+/g, ' ').split(' ');
}
